import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IconModule } from 'src/app/components/icon/icon.module';
import { ValidationRetryDialogComponent } from './validation-retry-dialog.component';
import { DialogModule } from '../dialog/dialog.module';
import { InputModule } from 'src/app/components/input/input.module';
import { ProgressSpinnerModule } from '../progress-spinner/progress-spinner.module';
import { ButtonModule } from '../button/button.module';

@NgModule({
  declarations: [ValidationRetryDialogComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    IconModule,
    DialogModule,
    InputModule,
    ProgressSpinnerModule,
    ButtonModule,
  ],
  exports: [ValidationRetryDialogComponent],
})
export class ValidationRetryDialogModule {}
